import { inject, InjectionKey, provide } from 'vue';
import ErrorUtil from '../../../util/ErrorUtil';
import FormAppCoordinatorProvider from '.';

/**
 * Convenience class for getting/setting a types safe version of the `FormAppCoordinatorProvider`
 * Technically this is a CoordinatorProvider provider.
*/
export default class CoordinatorProvider {
  /** The key for the main coordinator provider.  */
  private static readonly coordinatorKey: InjectionKey<FormAppCoordinatorProvider> = Symbol('FormAppCoordinatorProvider');

  /** Called once in the `FormApp` to init state */
  public static init(): FormAppCoordinatorProvider {
    const coordinatorProvider = new FormAppCoordinatorProvider();
    provide(CoordinatorProvider.coordinatorKey, coordinatorProvider);
    return coordinatorProvider;
  }

  /** Get the provider for this app */
  public static get(): FormAppCoordinatorProvider {
    const result = inject(CoordinatorProvider.coordinatorKey);
    if (!result) {
      throw ErrorUtil.internalError({ msg: 'CoordinatorProvider not initialized' });
    }

    return result as FormAppCoordinatorProvider;
  }
}
